var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.468559 0.470783C0.760838 0.177276 1.23571 0.176281 1.52922 0.468559L5.44789 4.37083C5.96167 4.88247 6.29478 5.21195 6.57219 5.4228C6.83228 5.62048 6.95393 5.6426 7.03449 5.64263C7.11506 5.64266 7.23672 5.62063 7.49695 5.42314C7.77452 5.21249 8.10787 4.88325 8.62203 4.37199L8.89627 4.09929C9.36511 3.63304 9.76922 3.23116 10.1362 2.9526C10.5297 2.654 10.9668 2.42808 11.505 2.42802C12.0432 2.42796 12.4804 2.65377 12.8739 2.95229C13.241 3.23077 13.6452 3.63256 14.1142 4.09871L20.25 10.1971V6.45417C20.25 6.03995 20.5858 5.70417 21 5.70417C21.4142 5.70417 21.75 6.03995 21.75 6.45417V12C21.75 12.4142 21.4142 12.75 21 12.75H15.4179C15.0036 12.75 14.6679 12.4142 14.6679 12C14.6679 11.5858 15.0036 11.25 15.4179 11.25H19.1815L13.0916 5.19728C12.5778 4.68659 12.2447 4.35774 11.9673 4.14732C11.7073 3.95006 11.5857 3.92801 11.5052 3.92802C11.4247 3.92803 11.3031 3.95011 11.0431 4.14743C10.7658 4.35791 10.4327 4.68684 9.91903 5.19765L9.64477 5.47037C9.1755 5.93704 8.77105 6.33926 8.40375 6.61801C8.01003 6.9168 7.57254 7.14283 7.03395 7.14263C6.49535 7.14244 6.05802 6.91609 5.66452 6.617C5.29742 6.33798 4.89326 5.93547 4.42433 5.46845C4.41275 5.45691 4.40112 5.44533 4.38945 5.43372L0.470783 1.53144C0.177276 1.23916 0.176281 0.764289 0.468559 0.470783Z",
    fill: "url(#paint0_linear_2296_1008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2296_1008",
    x1: 0.25,
    y1: 6.5,
    x2: 21.75,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.c86e3f5f2ec6d7029577a9de91f0115b.svg";
export { ForwardRef as ReactComponent };